import { render } from "./ImageUploader.vue?vue&type=template&id=5567b492&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"

import "./ImageUploader.vue?vue&type=style&index=0&id=5567b492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5567b492"]])

export default __exports__